import { Link } from 'react-router';
import { useState } from 'react';

import { api, useAPIContext } from '../../../api/context';
import toast from '../../../utils/toast';
import { Title } from '../../../utils/title';
import Layout from './Layout';
import styles from './Home.module.scss';

const Home = () => {

  const { token, setToken } = useAPIContext();

  const [ loading, setLoading ] = useState(false);

  const logout = () => {
    setToken(null);
  };

  const logoutAll = () => {

    setLoading(true);

    api(token).v1.auth.logout.all.post()
      .then(res => {
        setLoading(false);

        if (res.status === 200) {
          setToken(null);
        }

        if (res.status === 400) {
          toast.show(toast.KIND.ERROR, res.body);
        }
      })
      .catch(err => {
        setLoading(false);
        toast.show(toast.KIND.WARNING, err);
      });
  };

  return (
    <>
      <Title value='Profile' />
      <Layout>
        <div className={styles.root}>
          <div className={styles.content}>
            <h1>Profile Settings</h1>

            <ul>
              <li className={styles.sep}></li>

              <li>
                <Link to='/edit-profile'>
                  Edit Profile
                </Link>
              </li>

              <li>
                <Link to='/change-picture'>
                  Change Picture
                </Link>
              </li>

              <li>
                <Link to='/change-address'>
                  Change Address
                </Link>
              </li>

              <li>
                <Link to='/change-password'>
                  Change Password
                </Link>
              </li>

              <li>
                <Link to='/privacy-settings'>
                  Privacy Settings
                </Link>
              </li>

              <li>
                <Link to='/email-settings'>
                  Email Settings
                </Link>
              </li>

              <li>
                <Link to='/social-networks'>
                  Social Networks
                </Link>
              </li>

              <li className={styles.sep}></li>

              <li>
                <button onClick={() => logout()} disabled={loading}>
                  Logout
                </button>
              </li>

              <li>
                <button onClick={() => logoutAll()} disabled={loading}>
                  Logout All Devices
                </button>
              </li>
            </ul>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Home;